// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "qliq_protobuf/auth/module_access_mode.proto" (package "qliq_protobuf.auth", syntax proto3)
// tslint:disable
/**
 * @generated from protobuf enum qliq_protobuf.auth.ModuleAccessMode
 */
export enum ModuleAccessMode {
    /**
     * @generated from protobuf enum value: MODULE_BOT_DESIGNS_ADMIN = 0;
     */
    MODULE_BOT_DESIGNS_ADMIN = 0,
    /**
     * @generated from protobuf enum value: MODULE_CARE_CAMPAIGNS_ADMIN = 1;
     */
    MODULE_CARE_CAMPAIGNS_ADMIN = 1,
    /**
     * @generated from protobuf enum value: MODULE_AUTO_CAMPAIGNS_ADMIN = 2;
     */
    MODULE_AUTO_CAMPAIGNS_ADMIN = 2,
    /**
     * @generated from protobuf enum value: MODULE_CHAT_WIDGETS_ADMIN = 3;
     */
    MODULE_CHAT_WIDGETS_ADMIN = 3,
    /**
     * @generated from protobuf enum value: MODULE_FAQS_ADMIN = 4;
     */
    MODULE_FAQS_ADMIN = 4,
    /**
     * @generated from protobuf enum value: MODULE_ONCALL_SCHEDULES_ADMIN = 5;
     */
    MODULE_ONCALL_SCHEDULES_ADMIN = 5,
    /**
     * @generated from protobuf enum value: MODULE_QUICK_FORMS_ADMIN = 6;
     */
    MODULE_QUICK_FORMS_ADMIN = 6,
    /**
     * @generated from protobuf enum value: MODULE_FORM_SUBMISSIONS_ADMIN = 7;
     */
    MODULE_FORM_SUBMISSIONS_ADMIN = 7,
    /**
     * @generated from protobuf enum value: MODULE_REPORTS_ADMIN = 8;
     */
    MODULE_REPORTS_ADMIN = 8,
    /**
     * @generated from protobuf enum value: MODULE_SELF_SCHEDULES_ADMIN = 9;
     */
    MODULE_SELF_SCHEDULES_ADMIN = 9,
    /**
     * @generated from protobuf enum value: MODULE_VIRTUAL_CONVERSATIONS_ADMIN = 10;
     */
    MODULE_VIRTUAL_CONVERSATIONS_ADMIN = 10,
    /**
     * @generated from protobuf enum value: MODULE_VISIT_PATHS_ADMIN = 11;
     */
    MODULE_VISIT_PATHS_ADMIN = 11,
    /**
     * @generated from protobuf enum value: MODULE_GROUP_SETTINGS_ADMIN = 12;
     */
    MODULE_GROUP_SETTINGS_ADMIN = 12,
    /**
     * @generated from protobuf enum value: MODULE_QUICK_SIGN_SUBMISSIONS_ADMIN = 13;
     */
    MODULE_QUICK_SIGN_SUBMISSIONS_ADMIN = 13,
    /**
     * @generated from protobuf enum value: MODULE_SUPER_ADMIN = 14;
     */
    MODULE_SUPER_ADMIN = 14,
    /**
     * @generated from protobuf enum value: MODULE_GPT_STORE_ADMIN = 15;
     */
    MODULE_GPT_STORE_ADMIN = 15,
    /**
     * @generated from protobuf enum value: MODULE_QUICK_SIGN_TEMPLATES_ADMIN = 16;
     */
    MODULE_QUICK_SIGN_TEMPLATES_ADMIN = 16
}
